import leaderEric from '../images/leader-eric.png';
import leaderAlvin from '../images/leader-alvin.png';
import leaderWinnie from '../images/leader-winnie.jpg';

const teamMembersEN = [
  {
    name: 'Eric Lim Jing Jie',
    title: 'CEO & Co-founder',
    image: leaderEric,
    linkedin: 'https://www.linkedin.com/in/mampuaiericlim/',
  },
  {
    name: 'Alvin Lim Jing Yu',
    title: 'CTO & Co-founder',
    image: leaderAlvin,
    linkedin: 'https://www.linkedin.com/in/alvinlimjy/',
  },
  {
    name: 'Winnie Pang Wan Qi',
    title: 'Chief Operating Officer',
    image: leaderWinnie,
    linkedin: 'https://www.linkedin.com/in/pangwanqi/',
  },
];

const teamMembersZH = [
  {
    name: 'Eric Lim Jing Jie',
    title: '首席执行官兼联合创始人',
    image: leaderEric,
    linkedin: 'https://www.linkedin.com/in/mampuaiericlim/',
  },
  {
    name: 'Alvin Lim Jing Yu',
    title: '首席技术官兼联合创始人',
    image: leaderAlvin,
    linkedin: 'https://www.linkedin.com/in/alvinlimjy/',
  },
  {
    name: 'Winnie Pang Wan Qi',
    title: '首席运营官',
    image: leaderWinnie,
    linkedin: 'https://www.linkedin.com/in/pangwanqi/',
  },
];

const companyValuesEN = [
  {
    icon: '🎯',
    iconBg: 'var(--accent-light)',
    title: 'Actionable Intelligence',
    description: 'We turn raw conversation data into structured insights — KPI scores, customer profiles, and coaching priorities that drive real results.',
  },
  {
    icon: '🌏',
    iconBg: '#EFF6FF',
    title: 'Local-First, Global-Ready',
    description: 'Built for Malaysia with support for English, Malay, and Mandarin code-switching. Designed to scale across Southeast Asia and beyond.',
  },
  {
    icon: '🤝',
    iconBg: '#F0FDF4',
    title: 'Human + AI',
    description: 'AI handles the analysis, but humans make the decisions. We empower managers to coach better and salespeople to grow faster.',
  },
];

const companyValuesZH = [
  {
    icon: '🎯',
    iconBg: 'var(--accent-light)',
    title: '可执行的情报',
    description: '我们将原始的对话数据转化为结构化洞察——KPI 评分、客户画像与教练辅导优先事项，切实驱动业绩增长。',
  },
  {
    icon: '🌏',
    iconBg: '#EFF6FF',
    title: '本地为先，全球可用',
    description: '为马来西亚市场量身打造，支持英文、马来文与中文之间的自然切换。架构可扩展至整个东南亚乃至更广阔的市场。',
  },
  {
    icon: '🤝',
    iconBg: '#F0FDF4',
    title: '人 + AI',
    description: 'AI 负责分析，人类做出决策。我们帮助管理者更好地辅导团队，助力销售人员更快地成长。',
  },
];

export const getTeamMembers = (lang) => (lang === 'zh' ? teamMembersZH : teamMembersEN);
export const getCompanyValues = (lang) => (lang === 'zh' ? companyValuesZH : companyValuesEN);

// Backwards-compat exports
export const teamMembers = teamMembersEN;
export const companyValues = companyValuesEN;
